<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
     <div class="card p-0 lg:min-h-[calc(100vh_-_theme('spacing.header')_*_1.4)] xl:min-h-[calc(100vh_-_theme('spacing.header')_*_1.6)]">
         <div class="flex flex-col gap-2 sm:flex-center-between sm:flex-row px-4 py-5 sm:p-7 bg-gray-200/30 dark:bg-dark-card-shade">
             <div>
                 <h6 class="card-title">Transaction List</h6>
             </div>
             
             <a href="#" class="btn b-solid btn-primary-solid" data-modal-target="editModal" @click="addModal()">Add Voucher</a>
         </div>

     <div class="card">
    <div class="flex flex-col lg:flex-row items-center space-y-2 lg:space-y-0 lg:space-x-2">
        
        <!-- Start Date -->
        <div class="w-full lg:w-auto">
            <label for="startDate" class="block text-sm font-medium text-gray-700">From Date</label>
            <input type="date" id="startDate" v-model="startDate" class="w-full p-2 border border-gray-300 rounded" />
        </div>

        <!-- End Date -->
        <div class="w-full lg:w-auto">
            <label for="endDate" class="block text-sm font-medium text-gray-700">To Date</label>
            <input type="date" id="endDate" v-model="endDate" class="w-full p-2 ml-3 mb-4 border border-gray-300 rounded" />
        </div>

        <!-- Filter Button -->
        <div>
            <button  @click="filterPurchases" class="btn btn-primary-solid px-5  ml-5  lg:mt-0 cursor-pointer">Filter</button>
        </div>
    </div>

    <div class="flex flex-col lg:flex-row items-center space-y-4 lg:space-y-0 lg:space-x-2 mt-0">
        
        <!-- Vendor Filter: Branch -->
        <div class="w-full lg:w-auto" style="width: 250px;">
            <label for="employee_name" class="block text-sm font-medium text-gray-700">Search Employee</label>
            <select class="form-input w-full p-2 border border-gray-300 rounded" id="employee_name" ref="employee_name" v-model="sale.employee_name">
                
                <option value="All">ALL</option>
                <option value="CLEAR">CLEAR EMPLOYEE</option>
                <option v-for="(item, index) in employeeList" :key="index" :value="item.id">{{ item.name }}</option>
            </select>
        </div>

        <!-- Vendor Filter: Material Name -->
        <div class="w-full lg:w-auto mb-4" style="width: 250px; margin-bottom: 16px;">
            <label for="party_name" class="block text-sm font-medium text-gray-700">Party Name</label>
            <select class="form-input w-full p-2 border border-gray-300 rounded" id="party_name" ref="party_name" v-model="sale.party_name">
                <option value=""></option>
                <option value="All">ALL</option>
                <option value="CLEAR">CLEAR PARTY</option>
                <option v-for="(item, index) in partyList" :key="index" :value="item.id">{{ item.name }}</option>
            </select>
        </div>
    </div>
</div>

<div class="card">
    <!-- Static heading -->
    <div id="printable-content">
        <h1 class="print-only" style="text-align: center;">Zambre Patil Prayog Parivar</h1>
        <h1 class="print-only" style="text-align: center;">Transcation List</h1>
    </div>

    <button
        type="reset"
        @click="printReceipt"
        class="btn b-light btn-danger-light btn-sm"
    >
        Print
    </button>
    </div>

    <div class="printonly">
        From {{startDate}} To {{endDate}}
    </div>
        
<!-- Start All Language List Table -->
<div class="p-3 sm:p-2">
    <div class="overflow-x-auto scrollbar-table">
        <table id="transactionTable" class="table-auto w-full whitespace-nowrap text-left text-gray-500 dark:text-dark-text leading-none">
            <thead class="border-b border-gray-200 dark:border-dark-border font-semibold">
                <tr>
                    <th class="px-3.5 py-4">Tr.Id.</th>     
                    <th class="px-3.5 py-4">Entry Date</th>     
                    <th class="px-3.5 py-4">Employee Name</th>
                    <th class="px-3.5 py-4">Party Name</th>             
                    <th class="px-3.5 py-4">Total Amount</th>
                    <th class="px-3.5 py-4">Paid Amount</th>
                    <th class="px-3.5 py-4">Pyment Type</th>
                    <th class="px-3.5 py-4">Note</th>
                    <th class="px-3.5 py-4">Action</th>
                </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                <tr class="hover:bg-primary-200/50 dark:hover:bg-dark-icon hover:text-gray-500 dark:hover:text-white" v-for="(item, index) in catList" :key="item.id">
                    <td class="px-3.5 py-4">{{ item.id }}</td>
                      <td class="px-3.5 py-4">{{ item.entry_date }}</td>
                    <td class="px-3.5 py-4">{{ item.employee_name }}</td>
                    <td class="px-3.5 py-4">{{ item.party_name }}</td>
                    <td class="px-3.5 py-4">{{ item.amount }}</td>    
                    <td class="px-3.5 py-4">{{ item.paid }}</td>    
                    <td class="px-3.5 py-4">{{ item.paymenttype }}</td>
                    <td class="px-3.5 py-4">{{ item.note }}</td>
                    <td class="px-3.5 py-4">
                        <div class="flex items-center gap-1">

                            <!-- <button class="btn-icon btn-primary-icon-light size-7" @click="updateModal(item)">
                                <i class="ri-save-line text-inherit text-[13px]"></i>
                            </button> -->

                            <td>
                                <div class="flex items-center gap-1">
                                    <button class="btn-icon btn-primary-icon-light size-7" @click="singletranscation(item.id)">
                                        <i class="ri-add-line text-gray-900 dark:text-dark-text text-[14px]"></i>
                                    </button>
                                </div>
                            </td>  

                            <button class="btn-icon btn-primary-icon-light size-7"v-if="saleid > 0" @click="editModal(item)">
                                <i class="ri-edit-2-line text-inherit text-[13px]"></i>
                            </button>

                            <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)">
                                <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>

            <tfoot>
                <tr >
                    <td class="px-3.5 py-4">Total</td>
                    <td class="px-3.5 py-4"></td>
                    <td class="px-3.5 py-4"></td>
                    <td class="px-3.5 py-4"></td>
                    <td class="px-3.5 py-4">{{ totalAmount }}</td>
                    <td class="px-3.5 py-4">{{ totalPaid }}</td>
                    <td colspan="2" class="px-3.5 py-4">DUE AMOUNT :  {{ totalDue }}</td>
                    <td></td>
                </tr>
            </tfoot>

        </table>
    </div>
</div>
<!-- End All Language List Table -->

     </div>
 </div>
 <!-- End Main Content -->





<!-- Start Edit Modal -->
<div id="editModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full h-screen bg-black bg-opacity-50">
    <div class="p-4 w-full max-w-lg overflow-hidden">
        <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square h-full flex flex-col">
            <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                <i class="ri-close-line text-inherit text-xl leading-none"></i>
            </button>
            
            <div class="p-4 md:p-5 overflow-y-auto">
                <!-- <label>Date : <input type="date" v-model="cat.entry_date"></label> -->

                <div class="p-4 md:p-5">
                   
                    <div class="mt-7">
                        <label>
                            <input type="radio" value="employee" v-model="selectedOption" /> Employee
                        </label>
                        <label class="ml-4">
                            <input type="radio" value="party" v-model="selectedOption" /> Party
                        </label>
                    </div>
                    
                    <!-- Employee Dropdown -->
                    <div v-if="selectedOption === 'employee'" class="mt-4">
                        <label for="employee_name" class="block text-sm font-medium text-gray-700">Search Employee</label>
                        <select id="employee_name" v-model="cat.employeeid" class="form-input w-full p-2 border border-gray-300 rounded">
                            <option value="">Select an employee</option>
                            <option v-for="item in employeeList" :key="item.id" :value="item.id">{{ item.name }}</option>
                        </select>
                    </div>
                    
                    <!-- Party Dropdown -->
                    <div v-if="selectedOption === 'party'" class="mt-4">
                        <label for="branches_name" class="block text-sm font-medium text-gray-700">Search Party</label>
                        <select id="branches_name" v-model="cat.partyid" class="form-input w-full p-2 border border-gray-300 rounded">
                            <option value="">Select a party</option>
                            <option v-for="item in partyList" :key="item.id" :value="item.id">{{ item.name }}</option>
                        </select>
                    </div>

                    <div class="mt-7">
                        <label for="" class="form-label">Date *</label>
                        <input type="date" id="barcode" v-model="cat.entry_date" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                        </div>
                


                        <div v-if="selectedOption === 'employee'" class="mt-7">
                            <label for="" class="form-label">Total Amount *</label>
                            <input type="number" id="barcode" v-model="cat.amount" placeholder="Type Here"
                                class="form-input" required autocomplete="off">
                        </div>

                        <div class="mt-7">
                            <label for="" class="form-label">Paid Amount *</label>
                            <input type="number" id="barcode" v-model="cat.paid" placeholder="Type Here"
                                class="form-input" required autocomplete="off">
                        </div>
                     
                        <div class="mt-7">
                            <label for="tagname" class="form-label">Payment Type *</label>
                            <select   v-model="cat.paymenttype" class="form-input">
                                <option value="Upi">Upi</option>
                                <option value="Cheque">Cheque</option>
                                <option value="NEFTI">NEFTI</option>
                                <option value="Cash">Cash</option>
                            </select>

                        </div>

                        <div class="mt-7">
                            <label for="" class="form-label">Note *</label>
                            <input type="text" id="barcode" v-model="cat.note" placeholder="Type Here"
                                class="form-input" required autocomplete="off">
                        </div>
                     



             </div>




            </div>
            <div class="flex justify-end p-4">
                <button @click="save_category" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
            </div>
        </div>
    </div>
</div>


<!-- start update Modal -------------------------------------------------------------------------------------------------------------------->
<!-- Start Edit Modal -->
<div id="updateModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full h-screen bg-black bg-opacity-50">
    <div class="p-4 w-full max-w-lg overflow-hidden">
        <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square h-full flex flex-col">
            <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                <i class="ri-close-line text-inherit text-xl leading-none"></i>
            </button>
            
            <div class="p-4 md:p-5 overflow-y-auto">
                <!-- <label>Date : <input type="date" v-model="cat.entry_date"></label> -->

                <div class="p-4 md:p-5">
                   
                    <div class="mt-7">
                        <lable>Fill up While Receving Material.</lable>    
                        </div>
                        
                        <div class="mt-7">
                            <label for="" class="form-label">Check In *</label>
                            <input type="date" id="barcode" v-model="cat.checkin" placeholder="Type Here"
                                class="form-input" required autocomplete="off">
                        </div>
    
    
                        <div class="mt-7">
                            <label for="" class="form-label">Checkin Qty *</label>
                            <input type="number" id="barcode" v-model="cat.checkinqty" placeholder="Type Here"
                                class="form-input" required autocomplete="off">
                        </div>

                        <div class="mt-7">
                            <label for="" class="form-label">Note *</label>
                            <input type="text" id="barcode" v-model="cat.note" placeholder="Type Here"
                                class="form-input" required autocomplete="off">
                        </div>

                  



             </div>




            </div>
            <div class="flex justify-end p-4">
                <button @click="update_category" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
            </div>
        </div>
    </div>
</div>






<!-- end update Modal --------------------------------------------------------------------------------------------------------------------->






 <!-- Start Delete Modal -->
 <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
     <div class="p-4 w-full max-w-md max-h-full">
         <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
             <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                 <i class="ri-close-line text-inherit text-xl leading-none"></i>
             </button>
             <div class="p-4 md:p-5 text-center">
                 <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                 <div class="mt-5 text-center">
                     <h5 class="mb-1">Are you sure?</h5>
                     <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                     <div class="flex justify-center gap-2 mt-6">
                         <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                         <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                     </div>
                 </div>
             </div>
         </div>
     </div>
 </div>
 <!-- End Delete Modal -->
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'ProductCategory',
components: {
 
} ,
mounted(){
 if(this.$route.query.type){
        this.filter={"id":this.$route.query.q,"type":this.$route.query.type};
        this.getBasics();
 }


 
},

data() {
    const today = new Date().toISOString().split('T')[0];
 return {
     isAdd:0,
     isEdit:0,
     selectedOption: 'employee', // Default selection
     isDelete: 0,
     deleteId:0,
     startDate:new Date(Date.now() - 30 * 86400000).toISOString().split('T')[0],
     endDate: today,
     isTableVisible: false, // Initially table is hidden
     ledgerList:[],
     lastrecord:[],
     employeeList:[],
     branchList:[],
     plotList:[],
     partyList:[],
     materialList:[],
     addgroupList:[],
    //  items: [], // Ensure this is initialized as an array
     filteredItems: [],
     sale: {
        branch_name: null,
        party_name: null,
        employee_name:null,
        branches_name:null,
        plot_name:null,
        materials_name:null,
     },  // New property to store filtered group
     catList:[],
     allSuggestions: [], // Example suggestions
      filteredSuggestions: [],

     cat:{
        employeeid:'',
        partyid:'',
        entry_date:this.todayDate(),
        amount:'',
        paymenttype:'',
        note:'',
    },
filter:[],
     employees: {empname:'',emprole:'0',isMainAdmin:0},
 }
 
 }, 
watch:{
    catList(newVal,oldVal){
        try {
         
        if ($.fn.DataTable.isDataTable($('#transactionTable'))) {
            $('#transactionTable').DataTable().clear();
            $('#transactionTable').DataTable().destroy();
        } 
        this.catList=newVal;
        //this.initializeTable();   
        } catch (error) {
            
        }
    }
},
 computed: {
    totalAmount() {
      return this.catList.reduce((sum, item) => parseFloat(sum||0) + parseFloat(item.amount || 0), '');
    },
    totalPaid() {
      return this.catList.reduce((sum, item) => parseFloat(sum||0) + parseFloat(item.paid || 0), '');
    },
    totalDue() {
      return parseFloat(this.totalAmount||0) - parseFloat(this.totalPaid||0);
    },
  },


methods:{
    
    closeModal(){
        
            $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
            $("#updateModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
    },

    filterPendingRecords() {
    this.catList = this.catList.filter(item => 
        !item.checkin || item.checkin.trim() === '' || item.checkin === '0000-00-00'
    );
},

  

 todayDate()
    {
        const dateObj = new Date();
        var month=dateObj.getMonth()+1;
        var day=dateObj.getDate();
        const currentDate = dateObj.getFullYear()+"-"+((month<10)?'0'+month:month)+"-"+((day<10)?'0'+day:day);
        return currentDate;
    },

    


    filterPurchases() {
       // alert("hello");
       var self=this;
         axios.post('gettranscation',self.filter).then(function (response) {
               self.employeeList = response.data.employeelist;
               self.materialList = response.data.materiallist;
               self.branchList = response.data.branchlist;
               self.plotList = response.data.plotlist;
               self.catList=response.data.alltranscationlist;
               self.original_catList=response.data.alltranscationlist;
               self.partyList = response.data.partylist;
          
               
                }).then(()=>{
                        // self.cat.ledgerid=self.lastrecord.ledgerid;
                        // self.cat.groupid=self.lastrecord.groupid;

                        $("#employee_name").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Employee Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {

                                      //  $('#transactionTable').DataTable().clear();
                                        self.catList.slice(0); 
                                            if(event.target.value>0) {
                                                self.catList=self.original_catList.filter(item => item.employeeid === event.target.value);
                                               
                                            }else  if(event.target.value=='CLEAR') {
                                                         self.catList=self.original_catList.filter(item => item.partyid != 0);
                                            }else{
                                                 self.catList=self.original_catList;
                                            }    
                                         //   $('.datatable').DataTable().destroy();  
                                           ;       
                                            
                                        });


//-------------------------------------------------------------------------------------------------------------------------


                        $("#party_name").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Party Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                        // alert(event.target.value);
                                        //     self.sale.branchid=event.target.value; 
                                       // $('#transactionTable').DataTable().clear();
                                        // self.catList.slice(0); 
                                            self.catList.slice(0); 
                                            if(event.target.value>0) {
                                                self.catList=self.original_catList.filter(item => item.partyid === event.target.value);
                                               
                                            }else  if(event.target.value=='CLEAR') {
                                                         self.catList=self.original_catList.filter(item => item.employeeid != '0' &&  item.employeeid != null);
                                            }else{
                                                 self.catList=self.original_catList;
                                            }    
                                            //$('.datatable').DataTable().destroy();       
                                            ;         
                                            
                                        });
                     










                     
                       ;
                });
  },



 addModal(){
this.cat={employeeid:'',partyid:'',partyid:'',entry_date:this.todayDate(),amount:'',paymenttype:'',note:'',};


    
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
         $("#first_input").focus();
     this.isAdd=!this.isAdd;

     if(!this.isAdd)
         $("#updateModal").removeClass('hidden');
     else
         $("#updateModal").addClass('hidden');
         $("#first_input").focus();
     this.isAdd=!this.isAdd;




 },

 editModal(item){
     if(item){
         let copy = JSON.parse(JSON.stringify(item));
         this.cat=copy;
     }
     if(!this.isEdit)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },


 updateModal(item){
     if(item){
         let copy = JSON.parse(JSON.stringify(item));
         this.cat=copy;
     }
     if(!this.isEdit)
         $("#updateModal").removeClass('hidden');
     else
         $("#updateModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },


 printReceipt() {
            $('.datatable').DataTable().destroy(); 
             window.print();
    },



 
 deleteModal(id){
     this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },
 async getBasics() {
       var self=this;
         axios.post('gettranscation').then(function (response) {
               self.employeeList = response.data.employeelist;
               self.materialList = response.data.materiallist;
               self.branchList = response.data.branchlist;
               self.plotList = response.data.plotlist;
            //    self.catList=response.data.alltranscationlist;
               self.original_catList=response.data.alltranscationlist;
               self.partyList = response.data.partylist;
          
               
                }).then(()=>{
                        // self.cat.ledgerid=self.lastrecord.ledgerid;
                        // self.cat.groupid=self.lastrecord.groupid;

                        $("#employee_name").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Employee Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                        // $('#transactionTable').DataTable().clear();
                                        // $('#transactionTable').DataTable().destroy();  
                                         self.catList.slice(0); 
                                            if(event.target.value>0) {
                                                self.catList=self.original_catList.filter(item => item.employeeid === event.target.value);
                                               
                                            }else  if(event.target.value=='CLEAR') {
                                                         self.catList=self.original_catList.filter(item => item.partyid != 0);
                                            }else{
                                                 self.catList=self.original_catList;
                                            }    
                                         //   $('.datatable').DataTable().destroy();  
                                         ;     
                                            
                                        });


//-------------------------------------------------------------------------------------------------------------------------


                        $("#party_name").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Party Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                        // alert(event.target.value);
                                        //     self.sale.branchid=event.target.value; 
                                           // self.catList.slice(0); 
                                           
                                           // $('#transactionTable').DataTable().clear();
                                            self.catList.slice(0); 
                                            if(event.target.value>0) {
                                                self.catList=self.original_catList.filter(item => item.partyid === event.target.value);
                                               
                                            }else  if(event.target.value=='CLEAR') {
                                                         self.catList=self.original_catList.filter(item => item.employeeid != 0);
                                            }else{
                                                 self.catList=self.original_catList;
                                            }    
                                           // $('.datatable').DataTable().destroy();                
                                           ;     
                                        });
                     










                     
                       ;
                });
  },
  initializeTable(){ 
   // $('#transactionTable').DataTable().destroy();   
    this.$nextTick(() => {
            $('#transactionTable').DataTable({
            order: [[0, "desc"]], // Column index 3 (Age) in descending order
            });
        });
  },
  save_category() {
             var self = this; 
             axios.post('savetranscation', this.cat)
                 .then(response => {
                     var msg = response.data.msg;
                     var isSuccess = response.data.status;
                     self.catList=response.data.alltranscationlist;
                     self.cat={employeeid:'',partyid:'',partyid:'',entry_date:this.todayDate(),amount:'',paymenttype:'',note:'',};
                   //  $("#transactionTable").DataTable().destroy(true);
                     self.getBasics();  
                      self.$swal(msg);
                     if (isSuccess == 1) {
                         self.closeModal();
                     }
                 }).then(response => {

                    ;
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },

         update_category() {
             var self = this; 
             axios.post('updatematerialtranscation', this.cat)
                 .then(response => {
                     var msg = response.data.msg;
                     var isSuccess = response.data.status;
                     self.employees=response.data.userDetails;
                     self.cat={name:'',status:'Active'};
                     self.getBasics();  
                     self.closeModal();
                     //self.$swal(msg);
                     if (isSuccess == 1) {
                         self.closeModal();
                     }
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },


                 
         singletranscation(id) {
            window.open('/transcationlist?q=' + id+'&type=emp', '_blank');
        },







         delete_category() {
             var self = this; 
             axios.post('deletetranscation', {deleteId:this.deleteId})
                 .then(response => {
                   
                     self.catList=response.data.cats;
                     self.employees=response.data.userDetails; 
                    self.closeModal(); 
                    self.getBasics();
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },
}
}



</script>




<style scoped>
    tfoot{
        background: antiquewhite;
        font-size: medium;
        font-weight: 800;
    }
    tfoot td{
        height: 35px;
    }
    .print-only {
        display: none;
    }
    .printonly{
        display: none; 
    }
    
    @media print {
        .print-only {
            display: block; /* Show elements for print */
            text-align: center; /* Center alignment as needed */
            font-size: 16px; /* Font size adjustments if needed */
        }
        .printonly{
        display: block; 
    }
    }
    
    
    @media print {
        /* Hide unnecessary elements */
        button, select, input, h2, .header_class, .header, .card-title {
            display: none !important;
        }
        
    
        /* Adjust the layout */
        body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
        }
    
        /* Receipt container */
        .receipt-container, #printable-content {
            width: 100%;
            padding: 10mm;
            margin: auto;
            border: 1px solid #000;
        }
    
        /* Add a border and spacing to the table */
        table {
            width: 100%;
            border-collapse: collapse;
        }
    
        table th, table td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
            font-size: 12px;
            color: black !important; 
        }
    
        
        table th {
            background-color: #f2f2f2;
            font-weight: bold;
            color: black!important;
        }
    
        /* Center titles */
        h1, h2 {
            text-align: center;
            margin: 0 0 10px;
            font-size: 16px;
            font-weight: bold;
        }
    
        /* Add company branding details */
        #printable-content {
            text-align: center;
        }
    
        #printable-content h1 {
            font-size: 20px;
        }
    
        /* Add spacing between sections */
        .section {
            margin-bottom: 20px;
        }
    
        /* Performance container styling */
        .performance-container {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
        }
    
        .performance-box {
            flex: 1;
            padding: 5px;
            margin: 0 5px;
            border: 1px solid #ddd;
            font-size: 12px;
            text-align: center;
        }
    
        .performance-box.best {
            background-color: #c8e6c9;
        }
    
        .performance-box.good {
            background-color: #bbdefb;
        }
    
        .performance-box.average {
            background-color: #ffe0b2;
        }
    }
    
      
        .salary_input{
            padding: 5px;
            width: 70px;
        }
        .plotname{
            font-size: x-small;
        font-weight: 200;
        background: yellow;
        padding: 0px 2px;
        border-radius: 10px;
        }
    
        .performance-container {
          display: flex;
          gap: 20px;
        }
        .performance-box {
          padding: 1px;
          border-radius: 8px;
          color: white;
          text-align: center;
          font-weight: bold;
          width: 80px;
        }
        
        .Best1 {
          background-color: green;
        }
        .Good1 {
          background-color: blue;
        }
        .Average1 {
          background-color: orange;
        }
    
        .best {
      color: green;
    }
    .good {
      color: blue;
    }
    .average {
      color: orange;
    }
    </style>
    










<style>

.suggestions-list{
    line-height: 16px;
    background: bisque;
    padding: 10px;
}
.suggestions-list li{
    padding-top: 5px;
    border-bottom: 0.5px solid gray;
}

@media print {
    button, select, input, h2, .header_class, .header, .card-title,select,label,.select2 {
        display: none !important;
    }
    

}

    .suggestions-list{
    line-height: 16px;
    background: bisque;
    padding: 10px;
}
.suggestions-list li{
    padding-top: 5px;
    border-bottom: 0.5px solid gray;
}
</style>